<template>

    <TemplateBasic 
      v-bind:breadcrumb="breadcrumb"
      v-bind:permission="permission">

      <div 
        class="row form-group">

        <div class="col">
        </div>

        <AppSearch 
          ref="pageSearch"
          class="col-md-4"
          v-on:search-data-change="onSearchChange" />
        
      </div>

      <AppFilter 
        ref="carparkFilter" 
        filterKey="carparkID"
        v-on:filter-data-change="onFilterCarparkChange" />

      <AppFilterDateRange
        ref="dateRangeFilter"
        v-show="showCalendar"
        v-on:filter-data-change="onFilterDateChange" />

      <button v-show="showExportCSV" v-on:click="onCSVButtonClick" type="button" class="btn btn-warning">
        Export CSV
      </button>

      <AppFilter 
        ref="licenseFilter" 
        filterKey="licenseID"
        v-show="false"
        v-on:filter-data-change="onFilterLicenseChange" />

      <AppTable 
        ref="pageTable" 
        v-bind:tableParameter="PARAM"
        v-on:table-data-click="onTableDataClick" 
        v-on:table-page-change="onTablePageChange" />

      <TemplateFeedback class="m-t" ref="pageFeedback" />

    </TemplateBasic>

</template>

<script>
import TemplateBasic from "@/components/Template/TemplateBasic";
import TemplateButton from "@/components/Template/TemplateButton";
import TemplateFeedback from "@/components/Template/TemplateFeedback";
import AppFilterDateRange from "@/components/App/AppFilterDateRange";
import AppSearch from "@/components/App/AppSearch";
import AppPaging from "@/components/App/AppPaging";
import AppFilter from "@/components/App/AppFilter";
import AppTable from "@/components/App/AppTable";
import AppAddButton from "@/components/App/AppAddButton";
import AppForm from "@/components/App/AppForm";
import AppModalForm from "@/components/App/AppModalForm";
import validation from "@/components/Utility/Validation"
import helper from "@/components/Utility/Helper"
import iPayPaymentCode from "@/components/Param/iPayPaymentCode"

import PageBillCollectionSelect from "@/components/Page/Collection/PageBillCollectionSelect"

var querystring = require('querystring');
const PARAM = [
  {
    key: '_index',
    index: true,
  },
  {
    key: 'id',
    text: 'Ref. No.',
  },
  {
    key: '_carparkName',
    text: 'Car Park',
    table_custom: function(dataResult, dataIndex, dataParameter, parameterIndex) {
      let parameterItem = dataParameter[parameterIndex];
      let dataItem = dataResult[dataIndex];
      if(dataItem['jt-summary']) return;

      return `<a target="_blank" href="${helper.WEB_URL}/carparkForm?carparkID=${dataItem.carparkID}">${dataItem['_carparkName']}</a>`;
    },
  },
  {
    key: '_licenseNum',
    text: 'Parking License',
    table_custom: function(dataResult, dataIndex, dataParameter, parameterIndex) {
      let parameterItem = dataParameter[parameterIndex];
      let dataItem = dataResult[dataIndex];
      if(dataItem['jt-summary']) return;

      if(!dataItem['licenseID']) {
        return;
      }
      if(dataItem['_licenseStatus'] === 'Pending' || dataItem['_licenseStatus'] === 'Pending Initial Payment' || dataItem['_licenseStatus'] === 'Terminated') {
        return helper.plFormPLNum(dataItem._licenseNum, dataItem._carparkNum);
      }
      return `<a target="_blank" href="${helper.WEB_URL}/parkinglicenseView?licenseID=${dataItem.licenseID}">${helper.plFormPLNum(dataItem._licenseNum, dataItem._carparkNum)}</a>`;
    },
  },
  {
    key: '_customerAccount',
    text: 'Account Holder',
    table_custom: function(dataResult, dataIndex, dataParameter, parameterIndex) {
      let parameterItem = dataParameter[parameterIndex];
      let dataItem = dataResult[dataIndex];
      if(dataItem['jt-summary']) return;

      if(dataItem.isCompany) {
        return `<a target="_blank" href="${helper.WEB_URL}/companyForm?customerID=${dataItem.customerID}">${dataItem._customerName}</a>`;
      } else {
        return `<a target="_blank" href="${helper.WEB_URL}/personalForm?customerID=${dataItem.customerID}">${dataItem._customerName}</a>`;
      }
    },
  },
  {
    key: 'paymentName',
    text: 'Payment Method',
  },
  {
    key: '_updatedDate',
    text: 'Date Transaction',
  },
  {
    key: '_amount',
    text: 'Amount (RM)',
  },
  {
    key: '_finance',
    text: 'Finance (RM)',
  },
  {
    key: '_netAmount',
    text: 'Net Amount (RM)',
  },
];

export default {
  name: "PageReportRemittance",
  components: {
    TemplateBasic,
    TemplateButton,
    AppSearch,
    AppPaging,
    AppFilter,
    AppTable,
    AppAddButton,
    AppForm,
    AppModalForm,
    TemplateFeedback,
    AppFilterDateRange,
  },
  data () {
    return {
      permission : null,
      breadcrumb : [
        { name: 'Home', url: helper.WEB_URL },
        { name: 'Report' },
        { name: 'Remittance Fees' },
      ],

      PARAM,

      showCalendar: false,
      showExportCSV: false,
    }
  },
  mounted() {
    if(!helper.hasViewPermission(this.permission = helper.getPermission(this))) {
      return;
    }
    
    this.$refs['carparkFilter'].formatFilterOptionText = (dataItem) => dataItem.carparkCode ? `${dataItem.carparkCode} - ${dataItem.name}` : dataItem.name;
    this.$refs['licenseFilter'].formatFilterOptionText = option => {
      if(!option.licenseOperatorNum) {
        return 'All Parking Licenses';
      }
      
      let text = helper.plFormPLNum(option.licenseOperatorNum, option.carparkID);
      let customer = option['_customer'];
      text += customer ? ` ${customer.name} (${customer.nationalID})` : '';
      return text;
    };
    // this.$refs['dateRangeFilter'].filterDateStart = moment().subtract(6, 'day').startOf('day');
    this.$refs['dateRangeFilter'].filterDateStart = moment().startOf('day');
    this.$refs['dateRangeFilter'].filterDateEnd = moment().endOf('day');
    this.loadCarpark();
  },
  methods: {
    loadCarpark() {
      let feedbackItem = 'car park data';
      this.$refs['carparkFilter'].setFilterLoading('Loading ' + feedbackItem);

      this.$http
        .get(
          helper.SERVER_URL + '/api2/carpark/',
          helper.createAxiosConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          this.pageCarpark = response.data;

          // this.$refs['carparkFilter'].setFilterDataWithValueIfFirstLoad([].concat({name: 'All Car Parks'}, response.data), this.$route.query.carparkID);
          // // this.$refs['carparkFilter'].setFilterDataWithValueIfFirstLoad(response.data, this.$route.query.carparkID);
          // this.loadCustomer();
          this.setCarparInput();
        })
        .catch(error => {
          this.$refs['carparkFilter'].setFilterError(helper.parseAxiosErrorMessage(this, error, 'loading', feedbackItem));
        });
    },
    setCarparInput() {
      let feedbackItem = 'car park license data'
      this.$refs['pageFeedback'].setFeedbackLoading('Loading ' + feedbackItem);
      this.$http
        .get(
          helper.SERVER_URL + '/api2/license',
          helper.createAxiosConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          this.$refs['pageFeedback'].setFeedbackMessage();

          let allParkingLicense = response.data;
          this.pageCarpark = this.pageCarpark.filter(k => {
            return allParkingLicense.find(j => j.carparkID === k.id)
          });

          this.showCalendar = true;
          // this.$refs['carparkFilter'].setFilterDataWithValueIfFirstLoad(this.pageCarpark, this.$route.query.carparkID);
          this.$refs['carparkFilter'].setFilterDataWithValueIfFirstLoad([].concat({name: 'All Car Parks'}, this.pageCarpark), this.$route.query.carparkID);
          this.loadCustomer();
        })
        .catch(error => {
          this.$refs['pageFeedback'].setFeedbackError(helper.parseAxiosErrorMessage(this, error, 'loading', feedbackItem));
        });
    },
    loadCustomer() {
      let feedbackItem = 'customer data';
      this.$refs['pageFeedback'].setFeedbackLoading('Loading ' + feedbackItem);

      this.$http
        .get(
          helper.SERVER_URL + '/api2/customer/',
          helper.createAxiosConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          this.$refs['pageFeedback'].setFeedbackMessage();
          this.pageCustomer = response.data;
          this.loadLicense();
        })
        .catch(error => {
          this.$refs['pageFeedback'].setFeedbackError(helper.parseAxiosErrorMessage(this, error, 'loading', feedbackItem));
        });
    },
    loadLicense() {
      let feedbackItem = 'license data';
      this.$refs['licenseFilter'].setFilterLoading('Loading ' + feedbackItem);

      let url = helper.SERVER_URL + '/api2';
      if(this.$refs['carparkFilter'].filterValue) {
        url += '/carpark/' + this.$refs['carparkFilter'].filterValue;
      }
      url += '/license/';

      this.$http
        .get(
          url,
          helper.createAxiosConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          this.pageLicense = response.data;
          response.data.forEach(k => {
            k['_customer'] = this.pageCustomer.find(j => j.id === k.customerID);
            k['_carpark'] = this.pageCarpark.find(j => j.id === k.carparkID);
          });

          this.$refs['licenseFilter'].setFilterDataWithValueIfFirstLoad([].concat({name: 'All Parking Licenses'}, response.data), this.$route.query.licenseID);
          // this.$refs['licenseFilter'].setFilterDataWithValueIfFirstLoad(response.data, this.$route.query.licenseID);

          if(response.data && response.data.length > 0) {
            this.loadData();
          }
        })
        .catch(error => {
          this.$refs['licenseFilter'].setFilterError(helper.parseAxiosErrorMessage(this, error, 'loading', feedbackItem));
        });
    },
    loadData() {
      let startDate = this.$refs['dateRangeFilter'].filterDateStart;
      let endDate = this.$refs['dateRangeFilter'].filterDateEnd;

      let feedbackItem = 'payment history';
      this.$refs['pageFeedback'].setFeedbackLoading('Loading ' + feedbackItem);

      let url = helper.SERVER_URL + '/api2/collection?1=1';
      if(this.$refs['carparkFilter'].filterValue) {
        url += '&carparkID=' + this.$refs['carparkFilter'].filterValue;
      }
      if(this.$refs['licenseFilter'].filterValue) {
        let license = this.pageLicense.find(k => helper.compareID(k.id, this.$refs['licenseFilter'].filterValue));
        url += '&customerID=' + license.customerID;
      }
      url += '&paymentType=online&status=paid'
      url = helper.appendSearchQuery(url, this.$refs['pageSearch'].searchValue);
      // url = helper.appendPagingQuery(url, this.$refs['pageTable'].getCurrentPage());
      
      this.$http
        .get(
          url,
          helper.createAxiosConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          this.$refs['pageFeedback'].setFeedbackMessage('');
          response.data = response.data.filter(k => {
            if(this.$refs['carparkFilter'].filterValue) {
              if(!helper.compareID(k.carparkID, this.$refs['carparkFilter'].filterValue)) {
                return false;
              }
            }
            if(this.$refs['licenseFilter'].filterValue) {
              let license = this.pageLicense.find(k => helper.compareID(k.id, this.$refs['licenseFilter'].filterValue));
              if(!helper.compareID(k.customerID, license.customerID)) {
                return false;
              }
            }
            if(k.paymentType !== 'online' && k.paymentType !== 'Online') {
              return false;
            }
            return true;
          });

          console.log('start', startDate.format('YYYY-MM-DD HH:mm:ss'))
          console.log('end', endDate.format('YYYY-MM-DD HH:mm:ss'))

          this.pageCollection = response.data;
          this.pageCollection = this.pageCollection.filter(k => {
              let collectionDate = helper.parseDateTime(k['collectionDate']);
              // console.log(collectionDate.format('YYYY-MM-DD HH:mm:ss'))
              if(!collectionDate) {
                return false;
              }
              if(collectionDate.unix() < startDate.unix()) {
                return false;
              }
              if(collectionDate.unix() > endDate.unix()) {
                return false;
              }
              return true;
            })

          this.loadFund();
        })
        .catch(error => {
          this.$refs['pageFeedback'].setFeedbackError(helper.parseAxiosErrorMessage(this, error, 'loading', feedbackItem));
        })
    },
    loadFund() {
      let feedbackItem = 'payment history info';
      this.$refs['pageFeedback'].setFeedbackLoading('Loading ' + feedbackItem);

      let url = helper.SERVER_URL + '/api2/fund/online';

      this.$http
        .get(
          url,
          helper.createAxiosConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          this.$refs['pageFeedback'].setFeedbackMessage('');

          this.pageFund = response.data;

          // this.loadInvoiceLease();
          this.processData()
        })
        .catch(error => {
          this.$refs['pageFeedback'].setFeedbackError(helper.parseAxiosErrorMessage(this, error, 'loading', feedbackItem));
        })
    },
    async loadInvoiceLease() {
      let feedbackItem = 'payment history detail';
      this.$refs['pageFeedback'].setFeedbackLoading('Loading ' + feedbackItem);

      let url = helper.SERVER_URL + '/api2/invoiceLease';

      this.pageInvoiceLease = []

      for(let license of this.pageLicense) {
        await this.$http
          .get(
            url + '?licenseID=' + license['id'],
            helper.createAxiosConfig()
          )
          .then(response => {
            let resultMeta = helper.processAxiosResponse(this, response);

            this.pageInvoiceLease = this.pageInvoiceLease.concat(response.data)
          })
          .catch(error => {
            this.$refs['pageFeedback'].setFeedbackError(helper.parseAxiosErrorMessage(this, error, 'loading', feedbackItem));
          })
      }

      this.$refs['pageFeedback'].setFeedbackMessage('');
      this.processData();
    },

    async processData() {
      let temp = {};

      for(let collection of this.pageCollection) {
        try {
          collection['_dataRef'] = JSON.parse(collection['dataRef']);
        } catch(e) {              
        }

        collection['status'] = helper.convertPaymentStatus(collection['status']) || '';
        collection['_license'] = this.pageLicense.find(j => j.carparkID === collection.carparkID && j.customerID === collection.customerID);
        collection['licenseID'] = collection['_license']['id'];
        collection['_licenseStatus'] = collection['_license']['status'];
        collection['_licenseNum'] = collection['_license']['licenseOperatorNum'];
        collection['_carparkNum'] = collection['_license']['carparkID'];
        collection['_carpark'] = this.pageCarpark.find(j => j.id === collection['carparkID']) || {};
        collection['_carparkName'] = (collection['_carpark'] || {}).name;
        collection['_customer'] = this.pageCustomer.find(j => j.id === collection['customerID']) || {};
        collection['_customerName'] = (collection['_customer'] || {}).name;
        collection['_customerType'] = (collection['_customer'] || {}).isCompany ? 'Company' : 'Personal';
        collection['_updatedDate'] = helper.formatDateTime(collection['collectionDate']);
        collection['optional'] = {}

        let paymentInfo = this.pageFund.find(j => helper.compareID(j.RefNo, collection.id))
        if(paymentInfo) {
          try {
            collection['optional'] = JSON.parse(paymentInfo['optional'] || '{}')
          } catch(e) {
          }
          collection['_paymentMethod'] = iPayPaymentCode.find(j => helper.compareID(j.paymentId, paymentInfo['PaymentId']));
          if(collection['_paymentMethod'] && collection['_paymentMethod'].paymentMethod) {
            collection['paymentName'] = collection['_paymentMethod'].paymentMethod
          }
        }

        let collectionID = collection['id'];
        temp[collectionID] = temp[collectionID] || collection;

        temp[collectionID]._invoice = temp[collectionID]._invoice || [];
        temp[collectionID]._invoice.push(collection);

        temp[collectionID]._invoiceLease = temp[collectionID]._invoiceLease || [];

        let feedbackItem = 'payment history detail';
        this.$refs['pageFeedback'].setFeedbackLoading('Loading ' + feedbackItem);

        await this.$http
          .get(
            helper.SERVER_URL + '/api2/invoiceLease?invoiceID=' + collection.invoiceID,
            helper.createAxiosConfig()
          )
          .then(response => {
            let resultMeta = helper.processAxiosResponse(this, response);

            temp[collectionID]._invoiceLease = temp[collectionID]._invoiceLease.concat(response.data);
          })
          .catch(error => {
            this.$refs['pageFeedback'].setFeedbackError(helper.parseAxiosErrorMessage(this, error, 'loading', feedbackItem));
          })
      }

      this.$refs['pageFeedback'].setFeedbackMessage('');

      this.pageCollection = Object.keys(temp).map(k => temp[k]);

      let lastRow = {
        'jt-summary': true,
        '_amount': 0,
        '_finance': 0,
        '_netAmount': 0,
      }

      this.pageCollection.forEach(collection => {
        collection['_amount'] = 0;
        collection['_finance'] = 0;
        collection['_netAmount'] = 0;

        let invoiceLeases = collection._invoiceLease || []
        for(let invoiceLease of invoiceLeases) {
          if(invoiceLease.type.endsWith('CN')) {
            collection['_amount'] -= invoiceLease['inclusive'];
          } else {
            collection['_amount'] += invoiceLease['inclusive'];
          }
        }
        
        lastRow['_amount'] += collection['_amount'];

        let paymentRemittance = collection['_paymentMethod']
        if(collection['_paymentMethod'] && collection['_paymentMethod']['remittanceList']) {
          for(let date in collection['_paymentMethod']['remittanceList']) {
            let startDate = helper.parseDateTime(date)
            if(startDate.unix() < collection['collectionDate']) {
              paymentRemittance = collection['_paymentMethod']['remittanceList'][date]
            }
          }
        }

        let hasFinance = false
        if (collection['optional']) {
          try {
            if (collection['optional']['MDRValues'] && collection['optional']['MDRValues']['finance']) {
              hasFinance = true
              collection['_finance'] = parseFloat(collection['optional']['MDRValues']['finance'])
            } else if (collection['optional']['carddetails'] && collection['optional']['carddetails']['paymenttype'] === 'LOCAL CREDIT CARD') {
              hasFinance = true
              collection['_finance'] = collection['_amount'] / 100 * 1.65
            } else if (collection['optional']['carddetails'] && collection['optional']['carddetails']['paymenttype'] === 'LOCAL DEBIT CARD') {
              hasFinance = true
              collection['_finance'] = collection['_amount'] / 100 * 1.65
            } else if (collection['optional']['carddetails'] && collection['optional']['carddetails']['paymenttype'] === 'INT CREDIT CARD') {
              hasFinance = true
              collection['_finance'] = collection['_amount'] / 100 * 3.1
            } else if (collection['optional']['carddetails'] && collection['optional']['carddetails']['paymenttype'] === 'INT CREDIT CARD') {
              hasFinance = true
              collection['_finance'] = collection['_amount'] / 100 * 3.1
            }
          } catch(e) {
          }
          
          if (hasFinance) {
            collection['_netAmount'] = collection['_amount'] - collection['_finance'];

            lastRow['_finance'] += collection['_finance'];
            lastRow['_netAmount'] += collection['_netAmount'];

            collection['_amount'] = helper.formatMoney(collection['_amount']);
            collection['_finance'] = helper.formatMoney(collection['_finance']);
            collection['_netAmount'] = helper.formatMoney(collection['_netAmount']);
          }
        }
        
        if (!hasFinance) {
          if(!paymentRemittance 
            || (paymentRemittance['remittancePercent'] == undefined
            && paymentRemittance['remittancePercent'] === null
            && paymentRemittance['remittanceAmount'] === undefined
            && paymentRemittance['remittanceAmount'] === null)) {
              collection['_finance'] = '-'
              collection['_netAmount'] = '-'

              collection['_amount'] = helper.formatMoney(collection['_amount']);
          } else {
            if(paymentRemittance['paymentMethod'] === 'Shopeepay') {
              if(moment('2020-12-01').unix() < collection['collectionDate']) {
                collection['_finance'] = collection['_amount'] / 100 * 1
              } else {
                collection['_finance'] = collection['_amount'] / 100 * 1.5
              }
            } else {
              if(paymentRemittance['remittancePercent']) {
                collection['_finance'] = collection['_amount'] / 100 * paymentRemittance['remittancePercent']
              } else if(paymentRemittance['remittanceAmount']) {
                collection['_finance'] = paymentRemittance['remittanceAmount']
              } else {
                collection['_finance'] = 0; //boost is 0
              }
            }

            // collection['_netAmount'] = collection['_amount'] - collection['_finance'];
            collection['_netAmount'] = collection['_amount'] - Number(Math.round(collection['_finance']+'e2')+'e-2');

            lastRow['_finance'] += collection['_finance'];
            lastRow['_netAmount'] += collection['_netAmount'];

            collection['_amount'] = helper.formatMoney(collection['_amount']);
            collection['_finance'] = helper.formatMoney(collection['_finance']);
            collection['_netAmount'] = helper.formatMoney(collection['_netAmount']);
          }
        }
      });
      lastRow['_amount'] = helper.formatMoney(lastRow['_amount']);
      lastRow['_finance'] = helper.formatMoney(lastRow['_finance']);
      lastRow['_netAmount'] = helper.formatMoney(lastRow['_netAmount']);

      this.pageCollection = this.pageCollection.sort((a,b) => a.createDate - b.createDate);
      if(this.pageCollection && this.pageCollection.length > 0) {
        this.pageCollection.push(lastRow);
        this.showExportCSV = true;
      }

      this.$refs['pageTable'].setTableData(this.pageCollection);
    },

    onFilterCarparkChange(dataIndex) {
      this.showExportCSV = false;
      this.$refs['pageTable'].setCurrentPage(1);
      this.$refs['pageTable'].setTableData(null);
      this.loadLicense();
    },
    onFilterLicenseChange(dataIndex) {
      this.showExportCSV = false;
      this.$refs['pageTable'].setCurrentPage(1);
      this.$refs['pageTable'].setTableData(null);
      this.loadData();
    },
    onFilterDateChange(dataIndex) {
      this.showExportCSV = false;
      this.$refs['pageTable'].setCurrentPage(1);
      this.$refs['pageTable'].setTableData(this.pageReport = null);
      this.loadData();
    },
    onTablePageChange() {
      this.showExportCSV = false;
      this.loadData();
    },
    onSearchChange(dataIndex) {
      this.showExportCSV = false;
      this.$refs['pageTable'].setCurrentPage(1);
      this.$refs['pageTable'].setTableData(this.pageReport = null);
      this.loadData();
    },

    onAddButtonClick() {
    },
    onTableDataClick(tableData, tableDataIndex) {
    },

    onFormInput(formData, formParameter, input) {
    },

    onCSVButtonClick() {
      let carpark = this.pageCarpark.find(k => helper.compareID(k.id, this.$refs['carparkFilter'].filterValue))
      let startDate = this.$refs['dateRangeFilter'].filterDateStart;
      let endDate = this.$refs['dateRangeFilter'].filterDateEnd;

      var header = [];
      if(carpark) {
        header.push('Car Park Code: ' + carpark.carparkCode)
        header.push('Car Park: ' + carpark.name)
      }
      header.push('Report: Remittance Fees For The Month - ' + (startDate.month() + 1) + '/' + startDate.year())
      // printCSV('#jt-table', `Report Remittance Fees ${(startDate.month() + 1) + '/' + startDate.year()}`, header);
      printCSVjson('#jt-table', `Report Remittance Fees ${(startDate.month() + 1) + '/' + startDate.year()}`, header, this.pageCollection, this.PARAM);
    }
  },
};
</script>



// WEBPACK FOOTER //
// src/components/Page/Report/PageReportRemittance.vue